// Import react libs
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Import styles
import {
    MenuButton,
    MenuIcon,
    LateralMenuNav,
    MenuTable,
    MenuItem,
    MenuLink,
    Overlay,
    CloseButton,
    CloseIcon,
} from './style';

// Import assets
import { ReactComponent as menuIcon } from '../../assets/icons/menu.svg';
import { ReactComponent as closeIcon } from '../../assets/icons/close.svg';

// Import texts
import headerTexts from '../../texts/header';

function LateralMenu({ ICON_WIDTH = 30, latMenuMaxWidth, isAdminConnected }) {
    // Keep a use state to know if the lateral menu is open
    const [isLateralMenuOpen, setIsLateralMenuOpen] = useState(false);

    // Keep the page location in a variable
    const location = useLocation();

    // Reset the Search Input text when the page change
    useEffect(() => {
        setIsLateralMenuOpen(false);
    }, [location.key]);

    return (
        <>
            {isLateralMenuOpen && (
                <>
                    <LateralMenuNav latMenuMaxWidth={latMenuMaxWidth}>
                        <CloseButton
                            onClick={() => {
                                setIsLateralMenuOpen(false);
                            }}
                        >
                            <CloseIcon as={closeIcon} width={ICON_WIDTH} />
                        </CloseButton>
                        <MenuTable>
                            <MenuItem>
                                <MenuLink to="/">
                                    {headerTexts.homeLink}
                                </MenuLink>
                            </MenuItem>
                            <MenuItem>
                                <MenuLink to="/about">
                                    {headerTexts.aboutLink}
                                </MenuLink>
                            </MenuItem>
                            {isAdminConnected && (
                                <MenuItem>
                                    <MenuLink to="/statistics">
                                        {headerTexts.statisticsLink}
                                    </MenuLink>
                                </MenuItem>
                            )}
                        </MenuTable>
                    </LateralMenuNav>
                    <Overlay onClick={() => setIsLateralMenuOpen(false)} />
                </>
            )}
            <>
                <MenuButton
                    onClick={() => {
                        setIsLateralMenuOpen(true);
                    }}
                >
                    <MenuIcon as={menuIcon} width={ICON_WIDTH} />
                </MenuButton>
            </>
        </>
    );
}

export default LateralMenu;
